import { useMemo } from "react";

import { loadStripePromise, Elements } from "./.";

export const StripeWrapper = ({ children, stripeKey, ...rest }) => {
  const loadedStripePromise = useMemo(() => loadStripePromise(stripeKey), [stripeKey]);
  return (
    <Elements stripe={loadedStripePromise} {...rest}>
      {children}
    </Elements>
  );
};
